import { ChevronDown, MapPin } from "lucide-react";
import { IMAGES } from "@/data/content";

export function Hero({ onRegister }) {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      {/* background */}
      <div className="absolute inset-0">
        <img src={IMAGES.heroCrew} alt="Danseurs hip-hop AJDR Factory" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(10,12,14,0.55) 0%, rgba(10,12,14,0.3) 40%, rgba(10,12,14,0.96) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 20% 30%, rgba(229,169,32,0.18), transparent 45%)" }} />
      </div>

      {/* marquee band */}
      <div className="absolute top-24 md:top-28 inset-x-0 overflow-hidden opacity-[0.09] select-none pointer-events-none">
        <div className="marquee-track">
          {Array.from({ length: 2 }).map((_, k) => (
            <span key={k} className="font-display font-black text-[18vw] leading-none whitespace-nowrap text-cream pr-10">
              HIP-HOP · BREAK · POPPING · HOUSE · GRAFF · BEAT ·&nbsp;
            </span>
          ))}
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-8 pb-16 md:pb-24">
        <div className="inline-flex items-center gap-2 tag-emerald rounded-full px-3 py-1 mb-6 animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <MapPin className="w-3.5 h-3.5" />
          <span className="font-mono2 text-xs tracking-widest uppercase">Depuis 1996 · Albi</span>
        </div>

        <h1 className="font-display font-black uppercase tracking-tight text-cream text-4xl sm:text-6xl lg:text-8xl leading-[0.92] max-w-5xl animate-fade-up" style={{ animationDelay: "0.2s" }}>
          Pousse les portes<br />
          de la <span className="text-mustard">Factory</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base md:text-lg text-cream/70 leading-relaxed animate-fade-up" style={{ animationDelay: "0.35s" }}>
          Centre artistique dédié à la culture Hip-Hop. Un lieu de vie, de création et
          de refuge où la danse, le graff et le son fédèrent une véritable famille.
          Ici, on apprend à s'exprimer, à se dépasser et à croire en soi.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-fade-up" style={{ animationDelay: "0.5s" }}>
          <button data-testid="hero-register-btn" onClick={onRegister} className="btn-mustard rounded-full px-8 py-4 text-base">
            S'inscrire pour la saison 2026/2027
          </button>
          <button
            data-testid="hero-explore-btn"
            onClick={() => document.getElementById("disciplines")?.scrollIntoView({ behavior: "smooth" })}
            className="rounded-full px-8 py-4 text-base font-semibold border border-cream/25 text-cream hover:border-mustard hover:text-mustard transition"
          >
            Découvrir les disciplines
          </button>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 text-cream/50 animate-bounce">
        <ChevronDown />
      </div>
    </section>
  );
}
